/*
 *
 * ProfilePage reducer
 *
 */
import produce from 'immer';
import { CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE, TWO_FA_REQUEST, TWO_FA_SUCCESS, TWO_FA_FAILURE, ENABLE_TWO_FA_REQUEST, ENABLE_TWO_FA_SUCCESS, ENABLE_TWO_FA_FAILURE, DISABLE_TWO_FA_REQUEST, DISABLE_TWO_FA_SUCCESS, DISABLE_TWO_FA_FAILURE, UPDATE_PROFILE_NAME_REQUEST, UPDATE_PROFILE_NAME_SUCCESS, UPDATE_PROFILE_NAME_FAILURE, PROFILE_DELETE_REQUEST, PROFILE_DELETE_FAILURE, PROFILE_DELETE_SUCCESS, } from './constants';
export var initialState = {
    loading: false,
    updatingUserName: false,
    error: '',
    twoFASecret: '',
    requestedTwoFA: false,
    profileDeleteLoading: false,
};
function profilePageReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case CHANGE_PASSWORD_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case CHANGE_PASSWORD_SUCCESS:
                state.loading = false;
                state.error = '';
                break;
            case CHANGE_PASSWORD_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case TWO_FA_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case TWO_FA_SUCCESS:
                state.twoFASecret = action.twoFASecret;
                state.requestedTwoFA = true;
                state.loading = false;
                state.error = '';
                break;
            case TWO_FA_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case ENABLE_TWO_FA_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case ENABLE_TWO_FA_SUCCESS:
                state.loading = false;
                state.error = '';
                break;
            case ENABLE_TWO_FA_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case DISABLE_TWO_FA_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case DISABLE_TWO_FA_SUCCESS:
                state.loading = false;
                state.error = '';
                break;
            case DISABLE_TWO_FA_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case UPDATE_PROFILE_NAME_REQUEST:
                state.updatingUserName = true;
                state.error = '';
                break;
            case UPDATE_PROFILE_NAME_SUCCESS:
                state.updatingUserName = false;
                state.error = '';
                break;
            case UPDATE_PROFILE_NAME_FAILURE:
                state.updatingUserName = false;
                state.error = action.err;
                break;
            case PROFILE_DELETE_FAILURE:
                state.profileDeleteLoading = false;
                state.error = action.err;
                break;
            case PROFILE_DELETE_REQUEST:
                state.profileDeleteLoading = true;
                state.error = '';
                break;
            case PROFILE_DELETE_SUCCESS:
                state.profileDeleteLoading = false;
                state.error = '';
                break;
            default:
                break;
        }
    });
}
export default profilePageReducer;
